import React from 'react';
import { Link } from 'react-router-dom';
import { logout } from '../utils/auth';
import { usePermissoes } from '../utils/PermissoesContext';
import './Dropdown.css';

export default function DropdownConta({ onLinkClick }) {
  const { temPermissao } = usePermissoes();
  
  const handleLogout = () => {
    logout();
    if (onLinkClick) onLinkClick();
    window.location.href = '/sidebar/Home';
  };

  return (
    <div className="dropdown-submenu-content">
      {temPermissao('Grupo') && <Link to="/sidebar/MeusGruposDropdown" onClick={onLinkClick}>Meus grupos</Link>}
      <Link to="/sidebar/MinhaConta" onClick={onLinkClick}>Minha Conta</Link>
      <Link to="/sidebar/Configuracoes" onClick={onLinkClick}>Configurações</Link>
      <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>Sair</a>
    </div>
  );
}
